export default __webpack_public_path__ + "static/media/logo-sistema.16d9eebc.png";